// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"745ca770","191":"8e8038d4","206":"ae64e24e","265":"a0d0b162","266":"11dd6ce6","405":"53fdbd4a","558":"ec3a5d74","636":"91d6d188","677":"8c9aa2d8"}[chunkId] + ".chunk.js";
};